angular.module('thothApp.services')
.factory('ProjectActions', ['$mdDialog', '$rootScope', 'Project', '$state', 'toaster',
  function($mdDialog, $rootScope, Project, $state, toaster) {

  return {
    extendProject: function(scope, project) {
      scope.projectHash = {
        project: project,
        extend: true,
        title: 'Extender Proyecto'
      };
      var currentScrollPosition = window.scrollY;

      return $mdDialog.show({
        controller: $rootScope.CommentCtrl,
        templateUrl: 'views/comment_dialog.html',
        scope: scope,
        preserveScope: true,
        onRemoving: function() {
          window.scrollTo(0, currentScrollPosition);
        }
      }).then(function(result) {
        return Project.extendProject({
          id: result.id,
          project: {
            name: result.name,
            project_date: result.date,
            audit_comment: result.comment,
            project_type_catalog_id: result.project_type_catalog_id,
            eta: result.eta
          }
        }).then(function(response) {
          $state.go('app.projects.show', { projectId: response.data.id });
          toaster.pop('success', 'Proyecto', 'El proyecto se extendió correctamente');
        }, Project.error);
      });
    }
  };
}]);
